import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

interface Row {
  studentId: string;
  admissionNumber: string;
  scholarNumber: string | null;
  studentName: string;
  class: string;
  section: string;
  assignedSubjects?: string;
}

interface Props {
  rows: Row[];
  onAssign: (row: Row) => void;
}

const StudentSubjectTable: React.FC<Props> = ({ rows, onAssign }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Admission No</TableCell>
            <TableCell>Scholar No</TableCell>
            <TableCell>Student Name</TableCell>
            <TableCell>Class</TableCell>
            <TableCell>Section</TableCell>
            <TableCell>Assigned Subjects</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.studentId}>
              <TableCell>{r.admissionNumber}</TableCell>
              <TableCell>{r.scholarNumber || "-"}</TableCell>
              <TableCell>{r.studentName}</TableCell>
              <TableCell>{r.class}</TableCell>
              <TableCell>{r.section}</TableCell>
              <TableCell>{r.assignedSubjects || "-"}</TableCell>
              <TableCell align="right">
                <IconButton size="small" onClick={() => onAssign(r)} title="Assign / Edit Subjects">
                  <EditIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={7} align="center">
                No students found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StudentSubjectTable;
